import type { DailyNote } from '@/libs/interfaces'

import { MOCK_STORE_ID_1, MOCK_STORE_ID_2 } from './seed'

export const mockDailyNotes: DailyNote[] = [
  {
    storeDailyNoteID: 'daily-note-1',
    storeID: MOCK_STORE_ID_1,
    date: '2026-06-26',
    note: 'Busy morning, two no-shows rebooked for the afternoon.',
    createdAt: '2026-06-26T07:30:00Z',
    updatedAt: '2026-06-26T07:30:00Z',
  },
  {
    storeDailyNoteID: 'daily-note-2',
    storeID: MOCK_STORE_ID_1,
    date: '2026-06-29',
    note: 'New tire machine delivered, technicians trained in the afternoon.',
    createdAt: '2026-06-29T08:15:00Z',
    updatedAt: '2026-06-29T08:15:00Z',
  },
  {
    storeDailyNoteID: 'daily-note-3',
    storeID: MOCK_STORE_ID_1,
    date: '2026-06-30',
    note: 'Reminder: monthly safety inspection scheduled for 16:00.',
    createdAt: '2026-06-30T06:45:00Z',
    updatedAt: '2026-06-30T06:45:00Z',
  },
  {
    storeDailyNoteID: 'daily-note-4',
    storeID: MOCK_STORE_ID_2,
    date: '2026-06-27',
    note: 'Short staffed due to sick leave, prioritize booked jobs only.',
    createdAt: '2026-06-27T07:00:00Z',
    updatedAt: '2026-06-27T07:00:00Z',
  },
  {
    storeDailyNoteID: 'daily-note-5',
    storeID: MOCK_STORE_ID_2,
    date: '2026-06-30',
    note: 'Customer satisfaction survey results reviewed with the team.',
    createdAt: '2026-06-30T09:00:00Z',
    updatedAt: '2026-06-30T09:00:00Z',
  },
]
